import { render, staticRenderFns } from "./PitchesSong.vue?vue&type=template&id=df004d66"
import script from "./PitchesSong.vue?vue&type=script&lang=js"
export * from "./PitchesSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports